export const PICK_UP = "Pick-up";
export const DROP_OFF = "Drop-off";
export const CONTINUE = "Continue";
export const CHOOSE_DATES = "Choose Dates";
